import { render } from "./List.vue?vue&type=template&id=f222430e&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=f222430e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f222430e"

export default script